import React, {Component} from "react";
import {connect} from "react-redux";
import NewApplication from "../components/newApplication";
import {
	attachmentRemove,
	attachmentsChange,
	changeFormData,
	changeNewAppField, closeEditQuestionAnswerModal, openEditQuestionAnswerModal,
	receiveBadRequestPostNewApp,
	removeExtraOpponent,
	requestDeleteDraftedApplication,
	requestGetApplication,
	requestGetSolicitorGroupWorkSources,
	requestPatchApplication,
	requestPostNewApplication,
	updateExtraOpponents, updateFormQuestionAnswerAfterSubmit,
	updateMedicalExpertFees,
	getPolicyAsSolicitor,
	requestPostNewApplicationAsSolicitor
} from "../actions/newApplication";
import {requestGetSolicitors} from "../actions/agentsList";
import {push} from "connected-react-router";
import {requestBreachCausationCp} from "../actions/breachCausationCp";
import {requestNewApplicationFormMessage} from "../actions/newApplicationFormMessage";
import {changeNewSolicitorLawsysField} from "../actions/newSolicitor";
import {
	changeSubSettingsDamages,
	requestApplicationPremiumSettings, requestDeleteDocument,
	requestPatchApplicationPremiumSettings, requestApplicationAttachment,
} from "../actions/applicationPolicy";
import _ from "lodash";
import moment from 'moment';
import {getSolicitorGroupCaseTypes} from "../actions/groups";
import {
	ANSWER_UPDATE_ACTION,
	ANSWER_UPDATE_TYPE, APPLICATION_POLICY_VIEW,
	INVALID_DATES_ERROR_MESSAGE,
	LEGAL_ADVICE_TEXT
} from "../helpers/variables";
import {getHtmlValidDate, isAragUser, isSolicitorUser, readFileAsBase64Async, validateAmount} from "../helpers/functions";
import {requestLawsysFirms,requestLawsysFirmsWithAgents} from "../actions/lawsysFirms";
import {resetApplicationPremium} from "../actions/premiumSettingsWizard";
import {fetchEditingSettings, fetchEditingSettingsEditableByOptions} from "../actions/editingSettings";
import {
	checkIfUserRolesCanEditAnswerBasedOnEditingOption,
	getEditingSettingFromQuestionOrField
} from "../helpers/approvalSettings/functions";
import {
	getTopLevelQuestion,
	getTriggeredQuestionFromQuestionsMayBeTriggered,
	getDateQuestionMinimumValue,
	getDateQuestionMaximumValue,
	findQuestionById, checkQuestionsMayBetriggered,arrayUnique, getTriggeredQuestion
} from "../helpers/questions/functions";
import { resetApplicationStagedPremium } from "../reducers/stagedPremiumsWizard";
import { ALLOW_APP_FORM_EDIT_STATUSES, SHOW_APPLICATION_PREMIUM_STATUSES } from "../helpers/constants";

class NewApplicationHOC extends Component {

	constructor(props){
		super(props);
		this.state = {
			isEditModalOpen: false,
			isDeleteAnswerModalOpen: false,
			selectedItemForDelete: {
				item: null,
				editingSetting: null
			},
			isHistoryModalOpen: false,
			historyItem: {values: {}, entityId: null, editingSetting: {}}
		}
	}

	componentWillMount() {
		
		if(isAragUser(this.props.user.loggedInUser.roles)){
			 this.props.requestLawsysFirmsWithAgents(this.props.user.loggedInUser.token)
					}
		if(this.props.user.loggedInUser.solicitorGroupId !== null )
			this.props.getSolicitorGroupCaseTypes(this.props.user.loggedInUser.solicitorGroupId); //function that requests solicitor group case types
		// else this.props.getSolicitors(); //solicitors are needed for finding out the solicitor names by their ids in application premium settings
		this.props.requestNewApplicationFormMessage();
		if(this.props.user.loggedInUser.roles[0] === 'Solicitor' ) {
			this.props.requestPossibleWorkSources(this.props.user.loggedInUser.solicitorGroupId);
		}
		this.props.requestBreachCausationCp();

		this.props.fetchEditingSettings();
		this.props.fetchEditingSettingsEditableByOptions();
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.newApplication.posting && !nextProps.newApplication.posting && nextProps.newApplication.badMsg){
            if(isSolicitorUser(this.props.user.loggedInUser.roles) ) {
                this.props.requestPossibleWorkSources(this.props.user.loggedInUser.solicitorGroupId);
            }
		}

		if (this.props.user.loggedInUser.roles[0] === "Solicitor") {
			if (nextProps.newApplication.badMsg === "") {
				if (nextProps.newApplication.submitted === true) {
					if (nextProps.newApplication.selectedApplication.id) {
						this.props.push('/posted-application/' + nextProps.newApplication.selectedApplication.id);
						//TODO: Action submitted false
					}
				}
			}
		}
		else if (isAragUser(this.props.user.loggedInUser.roles)){
			if (nextProps.newApplication.badMsg === "") {
				if (nextProps.newApplication.submitted === true) {
					if (nextProps.newApplication.selectedApplication.id) {
						this.props.push('/application-and-policies/application-policy/' + nextProps.newApplication.selectedApplication.id);
						
					}
				}
			}
		}

		if(isAragUser(this.props.user.loggedInUser.roles)) {
			if (nextProps.applicationsAndPolicies.selectedApplication.hasOwnProperty('id') && (SHOW_APPLICATION_PREMIUM_STATUSES.includes(nextProps.applicationsAndPolicies.selectedApplication.policyStatusMachineName))) {
				if(nextProps.applicationPremiumSettingsEditId === '' && (nextProps.applicationPremiumSettingsIndicator === false) && (!nextProps.applicationPremiumSettingsBadResponse && (!nextProps.applicationPremiumSettingsFailedToFetchMessage))){
					if(!this.props.router.location.pathname.includes('new-application'))
						this.props.getApplicationPremiumSettings(_.last(this.props.router.location.pathname.split('/')));
				}
			}
		}

		if(this.props.patchingPs && !nextProps.patchingPs && !nextProps.applicationPremiumSettingsBadResponse){
			this.setState({
				...this.state,
				isEditModalOpen: false
			})
		}

		if (this.props.router.location.pathname.includes('new-application') ||
			(this.props.router.location.pathname.includes(APPLICATION_POLICY_VIEW) &&
				this.props.newApplication.selectedApplication.policyStatus === "Draft") || //2
			(this.props.router.location.pathname.includes(APPLICATION_POLICY_VIEW) &&
				this.props.newApplication.selectedApplication.policyStatus !== "Draft")) {
			let triggeredQuestions = [];
			var currentDisplayedQuestions = this.props.newApplication.triggeredQuestionsToDisplay;
			let questionsMayBeTriggered = checkQuestionsMayBetriggered(this.props.newApplication.formData, nextProps.newApplication.formData, nextProps.newApplication.triggeredQuestions)
			if (questionsMayBeTriggered.length > 0) {
				triggeredQuestions = getTriggeredQuestionFromQuestionsMayBeTriggered(nextProps.newApplication.formData, nextProps.newApplication.questionsTriggeredByQuestions.filter(x => questionsMayBeTriggered.includes(x.id)), nextProps.newApplication.questions);

				if (triggeredQuestions.length > 0) {
					var removeDuplicates = arrayUnique(currentDisplayedQuestions.concat(triggeredQuestions));
					this.props.changeNewAppField('triggeredQuestionsToDisplay', removeDuplicates);
				}
				if (nextProps.newApplication.triggeredQuestionsToDisplay.length != 0) {
					var newDisplayQuestions = nextProps.newApplication.triggeredQuestionsToDisplay.filter(el => !triggeredQuestions.includes(el))
					var affectedQuestions = newDisplayQuestions.filter(q => questionsMayBeTriggered.includes(q.id));
					var questionsToRemove = nextProps.newApplication.triggeredQuestionsToDisplay.filter(q => affectedQuestions.includes(q));
					if (questionsToRemove.length > 0) {
						var updatedDisplayedQuestions = nextProps.newApplication.triggeredQuestionsToDisplay.filter(q => !questionsToRemove.includes(q));
						this.props.changeNewAppField('triggeredQuestionsToDisplay', updatedDisplayedQuestions);
					}
				}
			}
			if (this.props.newApplication.triggeredQuestionsToDisplay.length == 0) {
				var initialTriggeredQuestions = [];
				var checkQuestionsInitial = this.groupRelativeQuestions(true);
				Object.keys(checkQuestionsInitial).map((key, index) => {

					checkQuestionsInitial[key].map(question => {
						if (question.questionDisplaySettings !== null) {
							var isTriggered = getTriggeredQuestion(nextProps.newApplication.formData, nextProps.newApplication.questions, nextProps.newApplication?.questions?.find(q => q.id === question.id))
							if (isTriggered) {
								initialTriggeredQuestions.push(question);
							}
						}
					})
				})
				if (initialTriggeredQuestions.length > 0) {
					this.props.changeNewAppField('triggeredQuestionsToDisplay', initialTriggeredQuestions);
				}
			}
	}
	}

	handleSolicitorFirmSelect = (lawsysId)=> {
		
		const parameters = {
			orderAsc: true,
			orderBySolicitorName:  false,
			orderByLawsysId:  false,
			orderByLawsysName:false,
			orderByUserName:  true,
			limit: null,
			offset:  0,
			lawsysId:lawsysId,
			search:  null ,
		};
		this.props.getSolicitors(parameters);
		this.props.changeNewSolicitorLawsysField({id:parseInt(lawsysId)})
		this.props.changeNewAppFormData('solicitorFirmIdSelected',lawsysId)
	}


	handleSolicitorSelect = (userId)=>{
			this.props.changeNewAppFormData('userId',userId)

			this.props.getSolicitorGroupCaseTypes(this.props.newSolicitor.newSolicitorFormData.solicitorGroupId);
			this.props.requestPossibleWorkSources(this.props.newSolicitor.newSolicitorFormData.solicitorGroupId);

	}

	openHistoryModal = (historyItem, entityId) => {
		let editingSetting = {};
		if(historyItem && !historyItem.isStandard && !historyItem.isParent){
			const parentQ = getTopLevelQuestion(historyItem, this.props.newApplication.selectedApplication.questionsDtos);
			editingSetting = this.mapEditingQuestionOrFieldToEditingSetting(parentQ);
		} else {
			editingSetting = this.mapEditingQuestionOrFieldToEditingSetting(historyItem)
		}
		this.setState({
			isHistoryModalOpen: true,
			historyItem: {values: historyItem, entityId: entityId ? entityId : null, editingSetting: editingSetting}
		})
	};

	closeHistoryModal = () => {
		this.setState({
			isHistoryModalOpen: false,
			historyItem: { values: {}, entityId: null, editingSetting: {}}
		})
	};

	openEditModal = () => {
		this.setState({
			...this.state,
			isEditModalOpen: true
		})
	};

	closeEditModal = () => {
		this.props.resetApplicationStagedPremium();
		this.props.resetApplicationPremium();
		this.setState({
			...this.state,
			isEditModalOpen: false
		})
	};

	openDeleteAnswerModal = (item, editingSetting) => {
		this.props.changeNewAppField("deleteModalOpen",true)
		this.setState({
			...this.state,
			selectedItemForDelete: {
				item: item,
				editingSetting: editingSetting,
			}
		})
	};

	closeDeleteAnswerModal = () => {
		this.props.resetApplicationPremium();
		this.setState({
			...this.state,
			selectedItemForDelete: null
		});
		this.props.changeNewAppField("deleteModalOpen",false)
		this.props.changeNewAppField("updatingQuestionAnswerFail", "")
	};

	onDeleteAnswerConfirm = () => {
		if (!this.state.selectedItemForDelete){
			return;
		}

		this.props.updateFormQuestionAnswerAfterSubmit({
			sendBody: {
				applicationId: this.props.newApplication.selectedApplication.id,
				applicationAnswerApprovalSettingId: this.state.selectedItemForDelete.editingSetting.id,
				entityId: this.state.selectedItemForDelete.item.id,
				applicationUpdateType: this.state.selectedItemForDelete.editingSetting.tableName === "ApplicationOpponent" ?
					ANSWER_UPDATE_TYPE.APP_OPPONENT : ANSWER_UPDATE_TYPE.APP_MED_EXP_FEES,
				applicationUpdateAction: ANSWER_UPDATE_ACTION.REMOVE,
				items: null
			}
		})
	};

	handleInputChange = (evt) => {
		this.props.changeNewAppField(evt.target.name, evt.target.value);
	};

	handleDateChange = (name, value, minDate, maxDate) => {
		if (!value) { //if value is  undefined
			if (name.target.value.length >= 8) {
				let split = name.target.value.split('/');
				if (split.length === 3) {
					if (split[2].length === 4) {
						let d = getHtmlValidDate(name.target.value);

						if (!moment(name.target.value, "DD/MM/YYYY").isValid() ) { //if the date is invalid
							this.props.changeNewAppFormData(name.target.name, '');
							return false;
						}
						else {
							if (minDate) { //if minDate exists
								let t = getHtmlValidDate(minDate);
								if (moment(d).isBefore(t)) {
									this.props.changeNewAppFormData(name.target.name, '');
									return false;
								}
							}
							if (maxDate) { //if max date exists
								let t = getHtmlValidDate(maxDate);
								if (moment(d).isAfter(t)) {
									this.props.changeNewAppFormData(name.target.name, '');
									return false;
								}
							}
						}
					}
				}
			}
		}

		let foundQuestion;
		if(value){
			foundQuestion = findQuestionById(name, this.props.newApplication.questions);
		} else {
			foundQuestion = findQuestionById(name.target.name, this.props.newApplication.questions);
		}

		if(foundQuestion){
			const minDate = getDateQuestionMinimumValue(foundQuestion, this.props.newApplication.formData, this.props.newApplication.questions);
			const maxDate = getDateQuestionMaximumValue(foundQuestion, this.props.newApplication.formData, this.props.newApplication.questions);
			let answer = value ? value : name.target.value;
			if(
				answer
				&& (
					(minDate && answer < minDate)
					|| (maxDate && answer > maxDate)
				)
			) {
				this.props.changeNewAppFormData(foundQuestion.id, '')
			}
		}

		value !== undefined ? //when user wants to clear the date the value is undefined
			(this.props.changeNewAppFormData(name, value)) : this.props.changeNewAppFormData(name.target.name, name.target.value);
	};

	handleSelectChange = (evt) => {
		let newFeaturedQuestions;
		newFeaturedQuestions = this.calculateFeaturedQuestions(evt.target.name, evt.target.value);
		this.props.changeNewAppFormData(evt.target.name, evt.target.value);
		this.props.changeNewAppField('featuredQuestions', newFeaturedQuestions);
	};

	handleViewSubmit = (evt) => {
		evt.preventDefault();
		this.props.changeNewAppField('showForm', true);
	if(isAragUser(this.props.user.loggedInUser.roles)){
	const payload={
			userId:this.props.newApplication.userId,
			caseTypeId:this.props.newApplication.selectedCaseType,
			subCaseTypeId:this.props.newApplication.selectedSubCaseType?this.props.newApplication.selectedSubCaseType:null
		}
			this.props.getPolicyAsSolicitor(payload);
	}
else{
		if (this.props.newApplication.selectedSubCaseType !== '') {
			this.props.getApplication(this.props.newApplication.selectedCaseType, this.props.newApplication.selectedSubCaseType);
		}
		else {
			this.props.getApplication(this.props.newApplication.selectedCaseType, null);
		}
	}
	};

	handleSave = () => {
		let applicationAnswersDtos = [];
		let sendBody = {};
		let confirmed = true;
		let formData = this.props.newApplication.formData;
		let questions = this.props.newApplication.questions;
		let applicationFormId = this.props.newApplication.application.applicationFormId;
		let solicitorReference = this.props.newApplication.solicitorFileReference;
		let clientName = this.props.newApplication.clientName;
		let postCode = this.props.newApplication.postCode;
		let address = this.props.newApplication.address;
		let dateOfBirth = this.props.newApplication.dateOfBirth;
		let workSourceId = this.props.newApplication.workSourceId;
		let attachments = this.props.newApplication.attachments;
		let patchedApplication = this.props.newApplication.patchedApplication;
		let extraOpponents = this.props.newApplication.extraOpponents;
		let medicalExpertFees = this.props.newApplication.medExpertFees;

		if(dateOfBirth !== ''){
			if(!moment(dateOfBirth, "DD/MM/YYYY", true).isValid()) {
				this.props.changeNewAppField('badMsg', INVALID_DATES_ERROR_MESSAGE);
				return false;
			}
			else {
				dateOfBirth = moment.utc(dateOfBirth, "DD/MM/YYYY").toISOString();
			}
		}

		if (solicitorReference !== '') {
			for (let index in formData) {
				//if answer does not map to a question for the current application form, skip it
				const questionAnswer = questions.find(question => question.id.toString() === index.toString());
				if(!questionAnswer){
					continue;
				}

				let answerItem = {
					questionId: index,
					optionId: '',
					text: formData[index]
				};
				loop1:
					for (let j = 0; j < questions.length; j++) {
						if (questions[j].hasOwnProperty('options') && (parseInt(index) === questions[j].id)) {
							if (questions[j].inputType === 'calendar') {
								let date ;
								if( formData[index]){
									if(!moment(formData[index], "DD/MM/YYYY", true).isValid()) {
										this.props.changeNewAppField('badMsg', INVALID_DATES_ERROR_MESSAGE);
										return false;
									}
									else {
										date =  moment.utc(formData[index], "DD/MM/YYYY").toISOString()
									}
								}
								else {
									date = null;
								}
								answerItem = {
									...answerItem,
									date: date
								};
							}
							if (questions[j].options.length > 0) {
								for (let k = 0; k < questions[j].options.length; k++) {
									if (questions[j].options[k].id === parseInt(formData[index])) {
										answerItem = {...answerItem, optionId: questions[j].options[k].id};
										break loop1;
									}
								}
							}
						}
					}
				if (answerItem.optionId !== '') {
					delete answerItem.text;
					applicationAnswersDtos.push(answerItem);
				}
				else {
					delete answerItem.optionId;
					if(answerItem.text !== ''){  applicationAnswersDtos.push(answerItem)}
				}
			}

			//find if the application form contains the medical expert fees question in order to post it
			let medicalExpertFeesToPost = [];
			const feesQuestionExists = questions.find(question => question.machineName === "EstimateForMedicalExpertFees");
			if(feesQuestionExists){
				medicalExpertFeesToPost = medicalExpertFees.filter((fee) =>
					(fee.name !== '')
					|| (fee.natureOfExpert !== '')
					|| (fee.whySpecificExpert !== '')
					|| (fee.breachCausationCpId !== '')
					|| (fee.partialEstimatedCost !== '')
					|| (fee.attendanceEstimatedCost !== '')
				);
			}

			//find if the current application contains the opponent question in order to post it or not
			let opponentsToPost = [];
			const opponentQuestionExists = questions.find(question => question.machineName === "OpponentName");
			if(opponentQuestionExists){
				opponentsToPost = extraOpponents;
			}

			if (patchedApplication.hasOwnProperty('id') || (this.props.user.loggedInUser.roles[0] !== 'Solicitor')) {
				if (patchedApplication.id !== 0 || (this.props.user.loggedInUser.roles[0] !== 'Solicitor')) {
					sendBody = {
						applicationAnswersDtos: applicationAnswersDtos,
						confirmed: confirmed,
						applicationFormId: applicationFormId,
						solicitorReference: solicitorReference,
						postCode: postCode,
						clientName: clientName,
						draft: true,
						attachments: attachments,
						id: (this.props.user.loggedInUser.roles[0] !== 'Solicitor') ? this.props.newApplication.selectedApplication.id : patchedApplication.id,
						applicationOpponents: opponentsToPost,
						applicationMedicalExpertFees: medicalExpertFeesToPost,
						address: address,
						dateOfBirth:  dateOfBirth,
						workSourceId: workSourceId
					};
					//patch
					this.props.patchApplication(sendBody)
				}
			}
			else {
				sendBody = {
					applicationAnswersDtos: applicationAnswersDtos,
					confirmed: confirmed,
					applicationFormId: applicationFormId,
					solicitorReference: solicitorReference,
					postCode: postCode,
					clientName: clientName,
					draft: true,
					attachments: attachments,
					applicationOpponents: opponentsToPost,
					applicationMedicalExpertFees: medicalExpertFeesToPost,
					address: address,
					dateOfBirth:  dateOfBirth,
					workSourceId: workSourceId
				};
				this.props.postNewApplication(sendBody);
			}
		}
		else {
			this.props.changeNewAppField('badMsg', `${LEGAL_ADVICE_TEXT} File Reference field must be filled before saving.`)
		}
	};

	handleSubmit = (evt) => {
		evt.preventDefault();
		let applicationAnswersDtos = [];
		let sendBody = {};
		let confirmed = false;
		let formData = this.props.newApplication.formData;
		let applicationFormId = this.props.newApplication.application.applicationFormId;
		let solicitorReference = this.props.newApplication.solicitorFileReference;
		let clientName = this.props.newApplication.clientName;
		let postCode = this.props.newApplication.postCode;
		let confirmation = this.props.newApplication.confirmation;
		let attachments = this.props.newApplication.attachments;
		let patchedApplication = this.props.newApplication.patchedApplication;
		let extraOpponents = this.props.newApplication.extraOpponents;
		let medicalExpertFees = this.props.newApplication.medExpertFees;
		let address = this.props.newApplication.address;
		let dateOfBirth = this.props.newApplication.dateOfBirth;
		let d = new Date();
		let date = d.toISOString();		
		let displayedQuestionIds = new Set(this.props.newApplication.triggeredQuestionsToDisplay.map(q => q.id));
		// Filter out the triggered questions that are not in displayedQuestionIds
		let triggeredKeys = Object.keys(this.props.newApplication.triggeredQuestions)
		.filter(key => !displayedQuestionIds.has(Number(key)))
		.map(Number);
		let questions = this.props.newApplication.questions.filter(question => !triggeredKeys.includes(question.id));


		if(dateOfBirth !== ''){
			if(!moment(dateOfBirth, "DD/MM/YYYY", true).isValid()) {
				this.props.changeNewAppField('badMsg', INVALID_DATES_ERROR_MESSAGE);
				return false;
			}
			else {
				dateOfBirth = moment.utc(dateOfBirth, "DD/MM/YYYY").toISOString();
			}
		}


		if (this.props.newApplication.duplicate) {
			confirmed = true
		}
		for (let index in formData) {
			//if answer does not map to a question for the current application form, skip it
			const questionAnswer = questions.find(question => question.id.toString() === index.toString());
			if(!questionAnswer){
				continue;
			}			

			let answerItem = {
				questionId: index,
				optionId: '',
				text: formData[index]
			};
			loop1:
				for (let j = 0; j < questions.length; j++) {
					if (questions[j].hasOwnProperty('options') && (parseInt(index) === questions[j].id)) {
						if (questions[j].inputType === 'calendar') {
							let date ;
							if( formData[index]){
								if(!moment(formData[index], "DD/MM/YYYY", true).isValid()) {
									this.props.changeNewAppField('badMsg', INVALID_DATES_ERROR_MESSAGE);
									return false;
								}
								else {
									date = moment.utc(formData[index], "DD/MM/YYYY").toISOString();
								}
							}
							else {
								date = null;
							}
							answerItem = {
								...answerItem,
								date: date
							};
							delete answerItem.text;
						}						
						if (questions[j].options.length > 0) {
							for (let k = 0; k < questions[j].options.length; k++) {
								if (questions[j].options[k].id === parseInt(formData[index])) {
									answerItem = {...answerItem, optionId: questions[j].options[k].id};
									break loop1;
								}
							}
						}
					}
				}
			if (answerItem.optionId !== '') {
				delete answerItem.text;
				applicationAnswersDtos.push(answerItem);
			}
			else {
				delete answerItem.optionId;
				if(answerItem.text !== ''){ applicationAnswersDtos.push(answerItem)}
			}
		}

		//find if the application form contains the medical expert fees question in order to post it
		let medicalExpertFeesToPost = [];
		const feesQuestionExists = questions.find(question => question.machineName === "EstimateForMedicalExpertFees");
		if(feesQuestionExists){
			//check if user has filled entired row of the medical expert fee table
			let medicalExpertFeesRowsWithEmptyValues = [];
			try {
				medicalExpertFeesRowsWithEmptyValues = medicalExpertFees.filter((fee) =>
					(fee.name.toString().trim() === '')
					|| (fee.natureOfExpert.toString().trim() === '')
					|| (fee.whySpecificExpert.toString().trim() === '')
					|| (fee.breachCausationCpId.toString().trim() === '')
					|| (fee.partialEstimatedCost.toString().trim() === '')
					|| (fee.attendanceEstimatedCost.toString().trim() === '')
				);
			} catch (e) {
				this.props.changeNewAppField('badMsg', 'Please, fill in all the medical expert fees table rows before submitting the application.');
				return ;
			}
			if (medicalExpertFeesRowsWithEmptyValues.length > 0) {
				this.props.changeNewAppField('badMsg', 'Please, fill in all the medical expert fees table rows before submitting the application.');
				return ;
			}
			medicalExpertFeesToPost = medicalExpertFees.filter((fee) =>
				(fee.name !== '')
				|| (fee.natureOfExpert !== '')
				|| (fee.whySpecificExpert !== '')
				|| (fee.breachCausationCpId !== '')
				|| (fee.partialEstimatedCost !== '')
				|| (fee.attendanceEstimatedCost !== '')
			);
		}

		//find if the current application contains the opponent question in order to post it or not
		let opponentsToPost = [];
		const opponentQuestionExists = questions.find(question => question.machineName === "OpponentName");
		if(opponentQuestionExists){
			opponentsToPost = extraOpponents;
		}

		//validate amount
		const invalidAmounts = questions.filter(question => {
			if (question.inputType === 'amount') {
				const answer = formData[question.id];
				const errMsg = validateAmount(answer, question.minimum);
				if (errMsg !== '') {
					this.props.changeNewAppField('badMsg', `Please enter a valid amount for ${question.name}`);
					return true;
				}
			}
			return false;
		});

		if (invalidAmounts.length > 0) {
			return false;
		}
		
		if (patchedApplication.hasOwnProperty('id')) {
			if (patchedApplication.id !== 0) {
				sendBody = {
					applicationAnswersDtos: applicationAnswersDtos,
					confirmed: confirmed,
					applicationFormId: applicationFormId,
					solicitorReference: solicitorReference,
					postCode: postCode,
					clientName: clientName,
					draft: false,
					confirmation: confirmation,
					attachments: attachments,
					id: patchedApplication.id,
					applicationOpponents: opponentsToPost,
					applicationMedicalExpertFees: medicalExpertFeesToPost,
					workSourceId: this.props.newApplication.workSourceId,
					address: address,
					dateOfBirth: dateOfBirth,
				};
				//patch
				this.props.patchApplication(sendBody)
			}
		}
		else {
			sendBody = {
				applicationAnswersDtos: applicationAnswersDtos,
				confirmed: confirmed,
				applicationFormId: applicationFormId,
				solicitorReference: solicitorReference,
				postCode: postCode,
				clientName: clientName,
				draft: false,
				confirmation: confirmation,
				attachments: attachments,
				applicationOpponents: opponentsToPost,
				applicationMedicalExpertFees: medicalExpertFeesToPost,
				workSourceId: this.props.newApplication.workSourceId,
				address: address,
				dateOfBirth:  dateOfBirth,
			};
			if(!isAragUser(this.props.user.loggedInUser.roles))
			{
				this.props.postNewApplication(sendBody);
			}
			else
			{
					this.props.requestPostNewApplicationAsSolicitor({sendBody:sendBody,userId:this.props.newApplication.userId});
			}
			
		}
	};

	onDrop = (files, questionId) => {
		files.forEach(async file => {
			const alreadyExists = !!this.props.newApplication.attachments.find(a => file.name === a.name);
			if(!alreadyExists){
				let attachment = {
					name: file.name,
					encodedFile: '',
					fileType: file.type,
					questionId: questionId ? questionId : null
				};
				const base64String = await readFileAsBase64Async(file);
				attachment = {...attachment, encodedFile: base64String};
				this.props.attachmentsChange(attachment);
			}

		});
	};

	onClickActionLink = (isPlain, opponentIndex, opponent, question) => {
		isPlain ?
			this.openDeleteAnswerModal(
				opponent,
				this.mapEditingQuestionOrFieldToEditingSetting(question)
			) : this.props.removeExtraOpponent(opponentIndex)
	}
	

	calculateFeaturedQuestions = (changedFieldId, changedFieldValue) => {
		const { newApplication, changeNewAppField } = this.props;
		const { formData, questions, featuredQuestions } = newApplication;
	   
		const parsedChangedFieldId = parseInt(changedFieldId);
		const parsedChangedFieldValue = parseInt(changedFieldValue);
	   
		let updatedFormData = { ...formData };
		let updatedFeaturedQuestions = new Set(featuredQuestions);
	   
		const handleChildQuestion = (childQuestion, isOptionSelected) => {
		  const childQuestionId = childQuestion.id;
		  const isChildQuestionFeatured = updatedFeaturedQuestions.has(childQuestionId);
	   
		  if (isOptionSelected && !isChildQuestionFeatured) {
			// Add the child question if it's not already featured
			updatedFeaturedQuestions.add(childQuestionId);
		  } else if (!isOptionSelected && isChildQuestionFeatured) {
			// Remove the child question if it's featured but the option is not selected
			delete updatedFormData[childQuestionId];
			updatedFeaturedQuestions.delete(childQuestionId);
		  }
		};
	   
		questions.forEach((question) => {
		  if (question.options && parsedChangedFieldId === question.id) {
			question.options.forEach((option) => {
			  const isOptionSelected = parsedChangedFieldValue === option.id;
			  option.childQuestions.forEach((childQuestion) => {
				handleChildQuestion(childQuestion, isOptionSelected);
			  });
			});
		  }
		});
	   
		changeNewAppField('formData', updatedFormData);
		return Array.from(updatedFeaturedQuestions);
	  };	  

	handleDeleteDraftedApplication = (selectedApplicationId) => {
		this.props.deleteDraftedApplication(selectedApplicationId);
		this.props.push('/application-and-policies')
	};

	handleSelectMultipleChange = (key, value,id) => {
		let selectedDamagesIndex;
		let selectedDamages = [...this.props.applicationPolicy.premiumSettingsSubSettingsDamages[id].selectedDamages];
		let checkedDamagesIds = [...this.props.applicationPolicy.premiumSettingsSubSettingsDamages[id].checkedDamagesIds];
		let damages = this.props.applicationPolicy.premiumSettingsDamages;
		if (this.props.applicationPolicy.premiumSettingsSubSettingsDamages[id].checkedDamagesIds.includes(value)) {
			let index = checkedDamagesIds.indexOf(value);
			if (index > -1) {
				checkedDamagesIds.splice(index, 1);
			}
			for (let i = 0; i < selectedDamages.length; i++) {
				if (selectedDamages[i].id === value) {
					selectedDamagesIndex = i;
					break;
				}
			}
			if (selectedDamagesIndex > -1) {
				selectedDamages.splice(index, 1);
			}
			this.props.changeSubSettingsDamages(id,'selectedDamages', selectedDamages);
			this.props.changeSubSettingsDamages(id,'checkedDamagesIds', checkedDamagesIds);
		}
		else {
			selectedDamages.push(...damages.filter(item => (parseInt(value) === item.id)));
			checkedDamagesIds.push(value);
			this.props.changeSubSettingsDamages(id,'selectedDamages', selectedDamages);
			this.props.changeSubSettingsDamages(id,'checkedDamagesIds', checkedDamagesIds);
		}
	};

	handleCheckedState = (damageId, group, id) => {
		if (group === 'selectedDamages') {
			let checkedDamagesIds = this.props.applicationPolicy.premiumSettingsSubSettingsDamages[id].checkedDamagesIds;
			if (checkedDamagesIds.includes(damageId))
				return true;
			else return false
		}
		else return false
	};


	removeMedicalExpertFeesTableRow = (key) => {
		let medicalExpertFees = [...this.props.newApplication.medExpertFees];
		medicalExpertFees.splice(key,1)
		this.props.changeNewAppField('medExpertFees', medicalExpertFees);

	};

	groupRelativeQuestions = (questionDisplaysettings=false) => {
		let questions = this.props.newApplication.questions.filter(q => q.isParent || (questionDisplaysettings && q.questionDisplaySettings !== null) );
		questions = _.sortBy(questions, ["groupSortOrder", "sortOrder"]);
		questions = _.groupBy(questions,'groupSortOrder');
		return questions;
	};

	handleCaseTypeChange = (evt) => {
		this.props.changeNewAppField(evt.target.name, evt.target.value);
		if(!evt.target.value){
			return ;
		}
		if(this.props.newApplication.selectedApplication.draft){
			this.props.getApplication(
				evt.target.value,
				null
			);
		}
	};

	handleSubCaseTypeChange = (evt) => {
		this.props.changeNewAppField(evt.target.name, evt.target.value);
		if(this.props.newApplication.selectedApplication.draft){
			this.props.getApplication(
				this.props.newApplication.selectedCaseType,
				evt.target.value?evt.target.value:null
			);
		}
	};

	checkIfQuestionIsEditable = (question, fieldName, tableName) => {
		const editingSetting = getEditingSettingFromQuestionOrField(question, fieldName, tableName, this.props.editingSettings);

		if(
			this.props.newApplication.selectedApplication
			&& !ALLOW_APP_FORM_EDIT_STATUSES.includes(this.props.newApplication.selectedApplication.policyStatusMachineName)
		) {
			return false;
		}

		if(!editingSetting){
			return false;
		}

		const editingOption = this.props.approvalOptions
			.find(option => option.id === editingSetting.applicationAnswerApprovalOptionId);
		if(!editingOption){
			return false
		}

		return  checkIfUserRolesCanEditAnswerBasedOnEditingOption(this.props.user.loggedInUser.roles, editingOption);
	};

	mapEditingQuestionOrFieldToEditingSetting = (questionAnswerForEdit) => {
		if(_.size(questionAnswerForEdit) === 0){
			return null;
		}

		if(questionAnswerForEdit.isStandard) {
			return getEditingSettingFromQuestionOrField(null, questionAnswerForEdit.machineName, null, this.props.editingSettings)
		}

		if(questionAnswerForEdit.machineName === "OpponentName"){
			return getEditingSettingFromQuestionOrField(questionAnswerForEdit, null, "ApplicationOpponent", this.props.editingSettings)
		}

		if(questionAnswerForEdit.machineName === "EstimateForMedicalExpertFees"){
			return getEditingSettingFromQuestionOrField(questionAnswerForEdit, null, "ApplicationMedicalExpertFees", this.props.editingSettings)
		}

		return getEditingSettingFromQuestionOrField(questionAnswerForEdit, null, null, this.props.editingSettings)
	};

	render() {
		return (
			<NewApplication
				applicationStagedPremiumSettings={this.props.applicationStagedPremiumSettings}
				AgentsList={this.props.agentsList}
				requestApplicationAttachment={this.props.requestApplicationAttachment}
				checkIfQuestionIsEditable={this.checkIfQuestionIsEditable}
				isEditModalOpen={this.state.isEditModalOpen}
				openEditModal={this.openEditModal}
				closeEditModal={this.closeEditModal}
				handleCaseTypeChange={this.handleCaseTypeChange}
				handleSubCaseTypeChange={this.handleSubCaseTypeChange}
				openEditQuestionAnswerModal={this.props.openEditQuestionAnswerModal}
				closeEditQuestionAnswerModal={this.props.closeEditQuestionAnswerModal}
				groupedQuestions={this.groupRelativeQuestions(this.props.router.location.pathname.includes(APPLICATION_POLICY_VIEW) && this.props.newApplication.selectedApplication.policyStatus !== "Draft")} //function that groups relative questions
				removeMedicalExpertFeesTableRow={this.removeMedicalExpertFeesTableRow}
				requestDeleteDocument={this.props.requestDeleteDocument}
				worksourceName={this.worksourceName}
				user = {this.props.user}
				router = {this.props.router}
				UserRole={this.props.user.loggedInUser.roles[0]}
				RemoveExtraOpponent={this.props.removeExtraOpponent}
				AttachmentRemove={this.props.attachmentRemove}
				DeleteDraftedApplication={this.handleDeleteDraftedApplication}
				HandleDateChange={this.handleDateChange}
				OnDrop={this.onDrop}
				onClickActionLink={this.onClickActionLink}
				UpdateExtraOpponents={this.props.updateExtraOpponents}
				HandleSubmit={this.handleSubmit}
				HandleSave={this.handleSave}
				HandleSelectChange={this.handleSelectChange}
				ChangeNewAppField={this.props.changeNewAppField}
				HandleFormCompChange={this.props.changeNewAppFormData}
				HandleViewSubmit={this.handleViewSubmit}
				HandleInputChange={this.handleInputChange}
				Store={this.props.newApplication}
				updateMedicalExpertFees={this.props.updateMedicalExpertFees}
				breachCausationCp={this.props.breachCausationCp}
				newApplicationFormMessage={this.props.newApplicationFormMessage}
				handleSelectMultipleChange={this.handleSelectMultipleChange}
				handleCheckedState={this.handleCheckedState}
				applicationPolicySubSettings={this.props.applicationPolicy.premiumSettingsSubSettingsDamages}
				editingSettings={this.props.editingSettings}
				mapEditingQuestionOrFieldToEditingSetting={this.mapEditingQuestionOrFieldToEditingSetting}
				isDeleteAnswerModalOpen={this.props.newApplication.deleteModalOpen}
				openDeleteAnswerModal={this.openDeleteAnswerModal}
				closeDeleteAnswerModal={this.closeDeleteAnswerModal}
				onDeleteAnswerConfirm={this.onDeleteAnswerConfirm}
				approvalOptions={this.props.approvalOptions}
				isHistoryModalOpen={this.state.isHistoryModalOpen}
				openHistoryModal={this.openHistoryModal}
				closeHistoryModal={this.closeHistoryModal}
				historyItem={this.state.historyItem}
				handleSolicitorSelect={this.handleSolicitorSelect}
				handleSolicitorFirmSelect={this.handleSolicitorFirmSelect}
				SolicitorFirms={this.props.lawsysFirms}
				groups={this.props.groups}
				triggeredQuestions={this.props.newApplication.questionsTriggeredByQuestions}
			/>
		)
	}
}


const mapStateToProps = (state) => {
	return {
		newApplication: state.newApplication,
		groups:state.groups,
		applicationsAndPolicies: state.applicationsAndPolicies,
		user: state.user,
		applicationPolicy: state.applicationPolicy,
		breachCausationCp: state.breachCausationCp,
		newApplicationFormMessage: state.newApplicationFormMessage,
		applicationPremiumSettingsEditId: state.premiumSettingsWizard.editId,
		applicationStagedPremiumSettings: state.stagedPremiumsWizard,
		applicationPremiumSettingsIndicator: state.premiumSettingsWizard.fetchingExistingPremium,
		applicationPremiumSettingsBadResponse: state.premiumSettingsWizard.badResponseMsg,
		applicationPremiumSettingsFailedToFetchMessage: state.premiumSettingsWizard.failedToFetchMessage,
		router: state.router,
		patchingPs: state.premiumSettingsWizard.patching,
		editingSettings: state.editingSettings.approvalSettings,
		approvalOptions: state.editingSettings.approvalOptions,
        agentsList: state.agentsList,
        lawsysFirms: state.lawsysFirms,
		newSolicitor:state.newSolicitor,

	}
};


const mapDispatchToProps = (dispatch) => {
	return {
		getApplication: (caseTypeId, subCaseTypeId) => {
			dispatch(requestGetApplication(caseTypeId, subCaseTypeId))
		},
		changeNewAppField: (field, value) => {
            dispatch(changeNewAppField(field, value))
        },
		changeNewAppFormData: (field, value) => {
			dispatch(changeFormData(field, value))
		},
		postNewApplication: (sendBody) => {
			dispatch(requestPostNewApplication(sendBody))
		},
		updateExtraOpponents: (key, value, arrayKey) => {
			dispatch(updateExtraOpponents(key, value, arrayKey))
		},
		patchApplication: (app) => {
			dispatch(requestPatchApplication(app))
		},
		deleteDraftedApplication: (id) => {
			dispatch(requestDeleteDraftedApplication(id))
		},
		attachmentsChange: (attachment) => {
			dispatch(attachmentsChange(attachment))
		},
		push: (url) => {
			dispatch(push(url))
		},
		attachmentRemove: (index) => {
			dispatch(attachmentRemove(index))
		},
		removeExtraOpponent: (opponentId) => {
			dispatch(removeExtraOpponent(opponentId))
		},
		updateMedicalExpertFees: (payload) => {
			dispatch(updateMedicalExpertFees(payload))
		},
		receiveBadRequestPostNewApp: (payload) => {
			dispatch(receiveBadRequestPostNewApp(payload))
		},
		requestBreachCausationCp: () => {
			dispatch(requestBreachCausationCp())
		},
		requestNewApplicationFormMessage: () => {
			dispatch(requestNewApplicationFormMessage())
		},
		requestPossibleWorkSources: (payload) => {
			dispatch(requestGetSolicitorGroupWorkSources(payload))
		},
		getApplicationPremiumSettings: (id) => {
			dispatch(requestApplicationPremiumSettings({id:id}));
		},
		requestPatchApplicationPremiumSettings: (payload) => {
			dispatch(requestPatchApplicationPremiumSettings(payload))
		},
		changeSubSettingsDamages: (key, field, value) => {
			dispatch(changeSubSettingsDamages(key, field, value))
		},
		requestDeleteDocument: (applicationId, attachmentId, relativeUrl) => {
			dispatch(requestDeleteDocument(applicationId, attachmentId, relativeUrl));
		},
		getSolicitorGroupCaseTypes: (groupId) => {
			dispatch(getSolicitorGroupCaseTypes(groupId))
		},
        getSolicitors: () => {
            dispatch(requestLawsysFirms())
        },
        openEditQuestionAnswerModal: (payload) => {
			dispatch(openEditQuestionAnswerModal(payload))
		},
        closeEditQuestionAnswerModal: (payload) => {
			dispatch(closeEditQuestionAnswerModal(payload))
		},
		resetApplicationPremium: (payload) => {
			dispatch(resetApplicationPremium(payload))
		},
		resetApplicationStagedPremium: (payload) => {
			dispatch(resetApplicationStagedPremium(payload))
		},
		fetchEditingSettings: (payload) => {
			dispatch(fetchEditingSettings(payload))
		},
		fetchEditingSettingsEditableByOptions: (payload) => {
			dispatch(fetchEditingSettingsEditableByOptions(payload))
		},
		updateFormQuestionAnswerAfterSubmit: (payload) => {
			dispatch(updateFormQuestionAnswerAfterSubmit(payload))
		},
		requestApplicationAttachment: (payload) => {
			dispatch(requestApplicationAttachment(payload))
		},
		getSolicitors: (payload) => {
            dispatch(requestGetSolicitors(payload))
        },
		getPolicyAsSolicitor: (payload) => {
            dispatch(getPolicyAsSolicitor(payload))
        },
		requestLawsysFirmsWithAgents: (payload) => {
            dispatch(requestLawsysFirmsWithAgents(payload))
        },
		requestPostNewApplicationAsSolicitor: (payload,username) => {
            dispatch(requestPostNewApplicationAsSolicitor(payload,username))
        },
		changeNewSolicitorLawsysField: (payload) => {
            dispatch(changeNewSolicitorLawsysField(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(NewApplicationHOC);
